import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";

function CenterTitleZ({ title, icon, content, className }) {
  return (
    <>
      {icon && title && (
        <div className={`center-title-box ${className} `}>
          {icon && <SvgIcn name={icon} />}
          {title && <h1>{title}</h1>}

        </div>
      )}
      {content && <div className="center-title-text">{content}</div>}
    </>
  );
}

export default CenterTitleZ;
